import '../App.css';
import React, { useState, useEffect } from 'react';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { PAGES } from '../constants/Pages';
import Header from './Header';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import Popper from '@mui/material/Popper';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { GET_LOGISTIC_FORWARDER } from '../graphqlDefs/freights/mutations';
import { useQuery } from '@apollo/client';
import { getMessage } from '../translations';

dayjs.extend(utc);
dayjs.extend(timezone);

function TransportAllRateScreen() {
  const [
    showLogisticForworderSelectionPopup,
    setShowLogisticForworderSelectionPopup,
  ] = useState(false);
  const [logisticForworderData, setLogisticForworderData] = useState('');
  const [logisticForwardersDropdownData, setLogisticForwardersDropdownData] =
    useState([]);
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [validityMonth, setValidityMonth] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const navigate = useNavigate();

  const filteredProvidersVariables = {
    filters: { type: 'FORWARDER' },
    searchText: null,
  };

  const { loading, error, data, refetch } = useQuery(GET_LOGISTIC_FORWARDER, {
    variables: { input: filteredProvidersVariables },
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (!loading && data) {
      const logisticForwNames = data.filteredProviders.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setLogisticForwardersDropdownData(logisticForwNames);
    }
  }, [loading, data]);
  
  const handleOpen = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleDateChange = (newValue, isStart) => {
    if (isStart) {
      setStartDate(newValue);
    } else {
      setEndDate(newValue);
    }
  };

  const generateValidityDates = (startDate, endDate) => {
    const timeZone = 'Asia/Kolkata';
  
    // eslint-disable-next-line max-len
    const firstValidityDate = startDate.tz(timeZone).set('hour', 15).set('minute', 0).set('second', 55).set('millisecond', 44);
    const firstValidityDateString = firstValidityDate.format('YYYY-MM-DD HH:mm:ss.SSS Z');
  
    // eslint-disable-next-line max-len
    const lastValidityDate = endDate.tz(timeZone).set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 999);
    const lastValidityDateString = lastValidityDate.format('YYYY-MM-DD HH:mm:ss.SSS Z');
  
    return {
      firstValidityDate: firstValidityDateString,
      lastValidityDate: lastValidityDateString,
    };
  };
  const handleClose = () => {
    if (startDate && endDate) {
      setInputValue(`${startDate.format('MM/DD/YYYY')} - ${endDate.format('MM/DD/YYYY')}`);
      const validityDates = generateValidityDates(startDate, endDate);
      setStartDate(validityDates.firstValidityDate);
      setEndDate(validityDates.lastValidityDate);
      
    } else if (startDate) {
      setInputValue(`${startDate.format('MM/DD/YYYY')} - `);
    } else if (endDate) {
      setInputValue(`- ${endDate.format('MM/DD/YYYY')}`);
    }
    setAnchorEl(null);
  };

  const handleGoButtonClick = (e) => {
    e.preventDefault();
    if (!logisticForworderData || !startDate || !endDate) {
      setShowValidationMessage(true);
    } else {
      navigate(
        `/${PAGES.TRANSPORTALLRATEAPP}/${logisticForworderData}&${startDate}&${endDate}`
      );
    }
    
  };
  const open = Boolean(anchorEl);
  const startImport = () => {
    // also update the state value when popup opens
    refetch();
  };

  return (
    <>
      <body>
        <Header />
        <section id='deliveries-section' className='active'>
          <div id='container12' className='container columns full screen'>
            <div className='wrapper'>
              <div
                className='main-inner'
                data-onvisible-trigger='1'
                data-reorder='1,0'
                data-reorder-breakpoint='medium'
                style={{ opacity: 1 }}
              >
                <div className='w-50'>
                  <div className='container12info'>
                    <h2 id='text29' className='style8'>
                      <span className='p'>
                        {getMessage('Upload transport all-in rate details')}
                      </span>
                    </h2>
                    <ul
                      id='buttons24'
                      className='style1 buttons'
                      style={{ opacity: 1 }}
                    >
                      <li>
                        <button
                          className='QuantityAddBtn button n01'
                          onClick={() => {
                            setShowLogisticForworderSelectionPopup(true);
                            startImport();
                          }}
                        >
                          <RiArrowDropRightLine className='startIcon' />{' '}
                          {getMessage('START_IMPORT')}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='w-40'>
                  <div id='image06' className='image full'>
                    <span className='frame deferred'>
                      <img
                        src='https://julesai.com/assets/images/image06.png'
                        data-src='done'
                        alt=''
                        style={{ opacity: 1 }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
      {showLogisticForworderSelectionPopup ? (
        <div className='overlay-box'>
          <div className='popup'>
            <a
              className='close'
              onClick={() => {
                setShowLogisticForworderSelectionPopup(false);
              }}
            >
              <svg
                className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium'
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                data-testid='CloseIcon'
              >
                <path
                  d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
                ></path>
              </svg>
            </a>
            <div className='content'>
              <form id='simpleForm'>
                <div className='AddCategoryBody'>
                  <h4>{getMessage('FREIGHT_POPUP')}</h4>

                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <Select
                      value={logisticForworderData}
                      onChange={(e) => setLogisticForworderData(e.target.value)}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem disabled value=''>
                        {getMessage('LOGISTIC_FORWARDER')}
                      </MenuItem>
                      {logisticForwardersDropdownData.map((listD) => (
                        <MenuItem key={listD.value} value={listD.value}>
                          {listD.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl
                    className='FormField'
                    sx={{ m: 1, minWidth: '47%' }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TextField
                        label="Select validity month"
                        value={inputValue}
                        onClick={handleOpen}
                        onChange={(e) => setValidityMonth(e.target.value)}
                        readOnly
                      />
                      <Popper
                        open={open} 
                        anchorEl={anchorEl} 
                        className={'date-pick-range-ad'}
                        placement="bottom-start">
                        <Box
                          sx={{ p: 2, border: 1, bgcolor: 'background.paper', 
                            display: 'flex', flexDirection: 'column', gap: 2 }}>
                          <Typography>Select Start Date</Typography>
                          <DatePicker
                            value={startDate}
                            onChange={(newValue) => handleDateChange(newValue, true)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                          <Typography>Select End Date</Typography>
                          <DatePicker
                            value={endDate}
                            onChange={(newValue) => handleDateChange(newValue, false)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                          <Button onClick={handleClose} variant="contained">Done</Button>
                        </Box>
                      </Popper>
                    </LocalizationProvider>
                    {/* <Select
                      value={validityMonth}
                      onChange={(e) => setValidityMonth(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value={''}>
                        {getMessage('Select validity month')}
                      </MenuItem>
                      <MenuItem value={'1'}>January</MenuItem>
                      <MenuItem value={'2'}>February</MenuItem>
                      <MenuItem value={'3'}>March</MenuItem>
                      <MenuItem value={'4'}>April</MenuItem>
                      <MenuItem value={'5'}>May</MenuItem>
                      <MenuItem value={'6'}>June</MenuItem>
                      <MenuItem value={'7'}>July</MenuItem>
                      <MenuItem value={'8'}>August</MenuItem>
                      <MenuItem value={'9'}>September</MenuItem>
                      <MenuItem value={'10'}>October</MenuItem>
                      <MenuItem value={'11'}>November</MenuItem>
                      <MenuItem value={'12'}>December</MenuItem>
                    </Select> */}
                  </FormControl>

                  

                  <div className='validationMsg'>
                    {showValidationMessage && !logisticForworderData && (
                      <p className='errorMsg'>
                        {getMessage('POPUP_LOADING_VALIDATION')}
                      </p>
                    )}
                  </div>
                  <div className='btnSection'>
                    <Button variant='contained' onClick={handleGoButtonClick}>
                      {getMessage('GO')}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default TransportAllRateScreen;
